/// <amd-module name="Test/ManualTestReports/TestReportsCommon/TestProgressReportSourceBase" />

import { AnalyticsODataClientBase } from "Analytics/Shared/Common/Sources/AnalyticsODataClientBase";
import * as CommonResources from "Test/ManualTestReports/TestReportsCommon/Resources";
import { ITfsPageService } from "Tfs/Platform/Page";
import { TestPointFieldNames, TestProgressFilterFields, TestResourceEntityNames, TestSuiteFieldNames } from "Test/ManualTestReports/TestReportsCommon/Constants";
import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import { IODataQueryResponse } from "Analytics/Shared/Common/Types";
import { IFilterState } from "VSSUI/Utilities/Filter";
import { ITestPointCategoryStringToCountMap, ITestProgressReportFilterState, ITestManagementSettings } from "Test/ManualTestReports/TestReportsCommon/Contracts";
import { FilterHelper } from "./FilterHelper";

export class TestProgressReportSourceBase extends AnalyticsODataClientBase {

    public queryAllTestPlans(): Promise<number[]> {
        let groupByStr = `groupby((TestPlanId,TestPlanTitle))`;
        let planIds: number[] = [];

        const queryOptions = {
            entityType: TestResourceEntityNames.Suites,
            project: this._getProjectId()
        } as ODataQueryOptions;

        queryOptions.$apply = `${groupByStr}`

        return this.queryOData(queryOptions).then((oDataQueryResponse: IODataQueryResponse) => {
            if (!oDataQueryResponse || !oDataQueryResponse.value) {
                throw new Error("Data is empty");
            }
            else {
                oDataQueryResponse.value.forEach((row: { [key: string]: number }) => {
                    planIds.push(row[TestSuiteFieldNames.PlanId]);
                });
                return planIds;
            }
        });
    }
    
    protected _getProjectId(): string {
        const tfsPageService = this.pageContext.getService<ITfsPageService>("ITfsPageService");
        const tfsPageData = tfsPageService.getData();
        if (tfsPageData && tfsPageData.project) {
            return tfsPageData.project.id;
        } else {
            throw new Error(CommonResources.ProjectDetailsUnavailableError);
        }
    }

    protected _getCurrentFilterState(filterState?: IFilterState, lastSelectedPlan?: number): Promise<ITestProgressReportFilterState> {

        const testPlanFilterValue = FilterHelper.getTestPlanFilterValue(filterState);

        if (filterState && testPlanFilterValue && testPlanFilterValue.length > 0) {
            if (testPlanFilterValue.length > 10) {
                return Promise.reject(new Error(CommonResources.PlanLimitError));
            }
            return Promise.resolve(FilterHelper.getTestProgressFilterState(filterState));;
        }

        else {
            return this.queryAllTestPlans().then((planIds: number[]) => {
                let selectedPlanIds: number[] = [];

                if (!filterState) {
                    if (lastSelectedPlan && planIds.indexOf(lastSelectedPlan) >= 0) {
                        selectedPlanIds = [lastSelectedPlan];
                    }
                    else {
                        selectedPlanIds = planIds && planIds.length > 0 ? [planIds[0]] : [];
                    }

                    return {
                        selectedPlanIds: selectedPlanIds,
                        selectedSuiteIds: [],
                        selectedConfigurations: [],
                        selectedPriorityValues: [],
                        selectedAssignedToValues: [],
                        selectedTesterValues: [],
                        selectedOutcomeValues: []
                    } as ITestProgressReportFilterState;
                }
                else {
                    const testProgressFilterState = FilterHelper.getTestProgressFilterState(filterState);
                    if (!testProgressFilterState.selectedPlanIds || testProgressFilterState.selectedPlanIds.length == 0) {
                        if (planIds.length > 10) {
                            throw new Error(CommonResources.PlanLimitError);
                        }
                        else {
                            testProgressFilterState.selectedPlanIds = planIds;
                        }
                    }
                    return testProgressFilterState;
                }
            });
        }
    }
}